export const isStringValid = stringValue => {
    if (stringValue.trim().length < 1 || stringValue.startsWith(' ') || stringValue.endsWith(' ')) {
        return false;
    } else {
        return true;
    }
}

export const isAbsolutePath = (path) => {
    if (typeof path !== 'string') return false;

    // Linux/Unix absolute path: starts with '/'
    if (path.startsWith('/')) return true;

    // Windows absolute path: starts with 'C:\', 'D:\', etc. or 'C:/' style
    if (/^[a-zA-Z]:[\\/]/.test(path)) return true;

    return false;
};


export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}